import { assignmentSelector } from './assignment';
import { authSelector } from './auth';
import { mobileSelector } from './mobile';
import { modalSelector } from './modal';

export const selectors = { assignmentSelector, authSelector, mobileSelector, modalSelector };
